var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[(_vm.isLoggedIn)?_c('PrivateMenu'):_c('PublicMenu'),_c('LoginMenu',{attrs:{"isLoggedIn":_vm.isLoggedIn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }